export const fakeApiCall = <T>(
  data: T,
  delay?: number,
  errorCode?: string,
) => new Promise<T>((resolve, reject) => {
  setTimeout(
    () => {
      if (errorCode) {
        reject(new Error(errorCode))
      } else {
        resolve(data)
      }
    },
    Number(delay),
  )
})
